import React from 'react';

import DataGrid, { Column, FilterRow, Summary, TotalItem } from 'devextreme-react/data-grid';

import { AppCard } from 'components/appComponents';

import { useGetDriverMixerSalaryDetailsQuery } from 'bus/driverMixerSalary/services/driverMixerSalary';

type Props = {
  id: number | string;
  dateBegin: string;
  dateEnd: string;
};

const ConsumptionNomenclatureSalaryInfo = React.forwardRef<any, Props>(({ dateBegin, dateEnd, id }, ref) => {
  const { data: driverMixerSalary } = useGetDriverMixerSalaryDetailsQuery({
    driverId: +id,
    dateBegin: dateBegin,
    dateEnd: dateEnd,
  });

  return (
    <div className="container-dev">
      <AppCard>
        <DataGrid
          dataSource={driverMixerSalary?.data || []}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={ref}
          wordWrapEnabled
        >
          <FilterRow visible={true} />
          <Column dataField="date" caption="Дата" dataType="datetime" sortOrder="asc" width={140} />
          <Column dataField="objectName" caption="Объект" width={300} />
          <Column dataField="factoryName" caption="Завод" width={150} />
          <Column dataField="requestId" caption="Номер отгрузки" />
          <Column dataField="quantity" caption="Объем" />
          <Column dataField="price" caption="Ставка" />
          <Column dataField="overRate" caption="Коэффициент" />
          <Column dataField="toPay" caption="К оплате, руб" />
          <Column dataField="adjustments" caption="Корректировка" />
          <Column dataField="cashFlow" caption="Касса" />

          <Summary>
            <TotalItem column="price" summaryType="sum" displayFormat="Итого: {0}" />
            <TotalItem column="toPay" summaryType="sum" displayFormat="Итого: {0}" />
            <TotalItem column="adjustments" summaryType="sum" displayFormat="Итого: {0}" />
            <TotalItem column="cashFlow" summaryType="sum" displayFormat="Итого: {0}" />
          </Summary>
        </DataGrid>
      </AppCard>
    </div>
  );
});

export default ConsumptionNomenclatureSalaryInfo;
